import { useEffect, useState, type ReactNode } from 'react';
import type { Session } from '@supabase/supabase-js';
import { isSupabaseConfigured, supabase } from '../lib/supabase';
import { AuthContext } from './AuthContext';

export function AuthProvider({ children }: { children: ReactNode }) {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(Boolean(supabase));

  useEffect(() => {
    if (!supabase) return;

    let active = true;
    void supabase.auth.getSession().then(({ data }) => {
      if (active) {
        setSession(data.session);
        setLoading(false);
      }
    });

    const { data } = supabase.auth.onAuthStateChange((_event, nextSession) => {
      setSession(nextSession);
      setLoading(false);
    });

    return () => {
      active = false;
      data.subscription.unsubscribe();
    };
  }, []);

  async function signIn(email: string, password: string) {
    if (!supabase) return '应用尚未配置数据库连接。';
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    return error?.message || null;
  }

  async function signOut() {
    await supabase?.auth.signOut();
  }

  return (
    <AuthContext
      value={{
        client: supabase,
        configured: isSupabaseConfigured,
        loading,
        session,
        user: session?.user || null,
        signIn,
        signOut,
      }}
    >
      {children}
    </AuthContext>
  );
}
